import React, {Component} from 'react';
import PropTypes from 'prop-types';
//import '../../style/Orderbook.css';
import * as firebase from 'firebase';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import GradeIcon from 'material-ui-icons/Grade';
import AttachMoneyIcon from 'material-ui-icons/AttachMoney';
import PlusOneIcon from 'material-ui-icons/PlusOne';
import TrendingUpIcon from 'material-ui-icons/TrendingUp';
import BusinessIcon from 'material-ui-icons/Business';
import AccountBoxIcon from 'material-ui-icons/AccountBox';
import SvgIcon from 'material-ui/SvgIcon';
import { CSSTransition } from 'react-transition-group'

const Fade = ({children, ...props}) => (
  <CSSTransition
    {...props}
    timeout={200}
    classNames="fade"
  >
    {children}
  </CSSTransition>
);


//receives sessionid and uid props from simulationContainer.js

//This component is responsible for displaying
//the stats of the user as well as the market

class TotalStats extends Component {
    constructor(props) {
        console.log("TotalStats constructor", props);
        super(props);
        this.state = {
            AverageBuyPrice: '-',
            AverageSellPrice: '-',
            MarketVWAP: '-',
            Cash: '-',
            ABC: '-',
            PL: '-',
            LastPrice: '-',
            TotalVol: '-',
            ThisPosition: '-',
            Mission: '-'
        };
    }

    /**
     * Declares all listeners
     */
    componentDidMount() {
        //console.log("TotalStats componentDidMount");

        this.cashRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Assets").child("Cash");
        this.statsRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Assets").child("INTC").child("Stats");
        this.vwapRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Assets").child("INTC");

        /// Grabs user cash value and sets corresponding state
        this.cashRef.on('value', snap => {
            if (snap.val() !== null) {
                this.setState({
                    Cash: snap.val()
                });
            }
        });

        /// Grabs user stat values and sets corresponding states
        this.statsRef.on('value', snap => {
            if (snap.val()) {
                this.setState({
                    AverageBuyPrice: snap.val().BuyVWAP,
                    AverageSellPrice: snap.val().SellVWAP,
                    PL: snap.val().PL,
                    ABC: snap.val().Shares,
                    ThisPosition: snap.val().ThisPosition,
                    Mission: snap.val().Mission
                });
            } else {
                this.setState({
                    AverageBuyPrice: '-',
                    AverageSellPrice: '-',
                    PL: '-',
                    ABC: '-',
                    ThisPosition: '-',
                    Mission: '-'
                });
            }
        });

        /// Grabs market stats and sets corresponding states
        this.vwapRef.on('value', snap => {
            if (snap.val()) {
                this.setState({
                    MarketVWAP: (snap.val().VWAP),
                    LastPrice: (snap.val().CurrentAssetPrice / 100).toFixed(2),
                    TotalVol: snap.val().TotalVolume
                });
            } else {
                this.setState({
                    MarketVWAP: '-',
                    LastPrice: '-',
                    TotalVol: '-'
                });
            }
        });

    }

    componentWillUnmount() {
        // console.log("TotalStats componentWillUnmount");
        this.statsRef.off();
        this.vwapRef.off();
        this.cashRef.off();
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.ABC !== this.props.ABC){
        this.fadeShares = true;
      } else {
        this.fadeShares = false;
      }
    }

    render() {
        //console.log("TotalStats render");
        return (
            <div className='total-stats-style'>
            <Card className='stat-card'><CardContent className='stat-data'>
                <SvgIcon viewBox="0 0 1000 1000">
                  <path d={"M91.75 142.86c-17.35 2.86-39.19 14.29-52.25 27.15-13.27 13.47-24.29 35.11-27.35 54.3-2.86 18.17-2.86 532.97 0 551.14 6.74 41.84 39.8 74.91 81.65 81.65 18.37 2.86 794.04 2.86 812.41 0 41.85-6.74 74.91-39.8 81.65-81.65 2.86-18.17 2.86-532.97 0-551.14-6.74-41.85-39.8-74.91-81.65-81.65-16.74-2.66-798.13-2.45-814.46.2zm703.21 72.67c4.49 35.31 15.11 57.77 38.78 81.45 23.27 23.68 42.87 32.66 83.28 38.58l7.55 1.23v326.19l-9.59 1.23c-35.52 4.49-57.77 15.1-81.24 38.78-23.68 23.47-34.29 45.72-38.78 81.04l-1.22 9.8H206.27l-1.23-7.55c-3.47-24.09-6.12-33.88-13.68-49.6-6.74-13.88-11.63-20.62-24.9-33.68-23.68-23.68-46.13-34.29-81.45-38.78l-9.59-1.23V336.77l7.76-1.23c24.7-3.47 33.89-6.12 49.4-13.68 13.68-6.53 20.82-11.84 33.89-24.9 23.88-23.88 32.66-42.87 38.58-83.49l1.23-7.55h587.46l1.22 9.61z M486.32 275.13c-5.92 2.86-10.82 7.35-15.92 15.11l-7.55 11.23-9.39-2.86c-20.62-6.12-36.33-1.84-44.91 12.66-4.08 6.94-4.49 9.8-3.47 22.86l1.23 14.9-10.62 4.69c-28.78 13.47-33.68 36.13-12.66 58.58l9.39 10-5.71 14.08c-6.12 15.72-5.92 22.86 1.02 34.29 5.31 8.78 14.49 13.27 29.8 14.49l12.45 1.02 3.47 12.25c4.29 15.11 9.19 22.46 18.37 26.74 12.04 5.72 21.64 4.29 35.52-4.9l12.25-8.37 12.86 8.37c14.29 9.19 23.88 10.41 35.72 4.9 9.19-4.49 14.08-11.63 18.37-26.94l3.47-12.66h8.37c20.21 0 33.48-8.57 38.17-24.49 2.66-8.98 2.66-9.8-6.53-32.05-2.66-6.33-2.45-6.74 6.74-16.53 21.23-22.66 16.33-45.32-12.45-58.58l-10.41-4.9 1.23-13.88c1.02-12.04.41-15.11-3.68-22.86-7.96-15.31-23.47-20-44.91-13.68l-9.39 2.86-7.55-11.23c-7.76-11.63-19.19-18.98-29.6-18.98-2.86 0-8.98 1.84-13.68 3.88zM216.68 403.32c-2.45.41-5.92 3.06-7.76 5.72-2.86 4.49-2.86 5.51.41 12.25 3.88 8.57 11.63 13.06 22.66 13.47 4.9.2 5.92.61 3.06 1.23-2.45.41-5.92 3.06-7.76 5.71-2.65 4.08-2.65 5.51 0 11.84 5.31 13.06 8.78 13.68 68.79 13.68h53.28l-1.02-7.76c-.41-4.08 0-12.86 1.02-19.19 1.84-10.21 1.63-12.45-2.04-17.35-2.04-3.06-5.1-9.19-6.74-13.47l-2.65-7.55-58.38.2c-32.05.2-60.22.81-62.87 1.22zM660.24 407.41c-.61 3.26-3.67 9.19-6.53 13.68-4.08 6.33-4.7 9.19-3.67 15.31.82 4.08 1.43 12.66 1.22 18.98l-.2 11.84h53.68c58.58 0 60.83-.41 67.36-11.84 4.9-8.37 3.27-15.72-4.08-18.37l-5.71-2.04 6.74-.2c9.8-.2 17.76-5.1 21.64-13.47 3.27-6.74 3.27-7.96.41-12.04-1.63-2.65-5.92-5.31-9.59-6.12-3.47-.61-31.84-1.22-63.08-1.22h-56.75l-1.44 5.49zM249.54 583.97c-13.06 6.33-12.65 38.17.61 44.29 3.67 1.63 72.87 2.25 251.68 2.25 231.88 0 246.99-.21 251.07-3.67 9.59-7.55 9.59-34.09 0-41.85-4.08-3.27-18.99-3.47-251.68-3.27-168.6.01-248.62.82-251.68 2.25zM298.73 681.54c-13.06 5.31-12.66 38.58.41 44.7 3.67 1.63 60.01 2.25 202.08 2.25H698.2l4.9-4.9c9.19-9.19 9.19-30.01 0-39.19l-4.9-4.9-197.59.2c-108.59.01-199.43.82-201.88 1.84z"}/>
                </SvgIcon>
                <Typography>Shares:</Typography>
                <Fade in={!!this.fadeShares}>
                <Typography className={'the-stat'}>
                {this.state.ABC}</Typography>
                </Fade>
            </CardContent></Card>
                <Card className='stat-card'>
                    <CardContent className='stat-data'>
                    <GradeIcon/>
                    <Typography >Mission:</Typography><Typography className={'the-stat'}>{this.state.Mission}
                    </Typography>
                    </CardContent>
                </Card>
                <Card className='stat-card'>
                    <CardContent className='stat-data'>
                    <AttachMoneyIcon/>
                    <Typography>Cash:</Typography><Typography className={'the-stat'}>
                    {this.state.Cash}</Typography>
                    </CardContent>
                </Card>

                <Card className='stat-card'><CardContent className='stat-data'>
                    <TrendingUpIcon/>
                    <Typography>P/L:</Typography><Typography className={'the-stat'}>
                    {this.state.PL}</Typography>
                </CardContent></Card>
                <Card className='stat-card'><CardContent className='stat-data'>
                    <AccountBoxIcon/>
                    <Typography>Average Buy:</Typography><Typography className={'the-stat'}>
                    {this.state.AverageBuyPrice}</Typography>
                </CardContent></Card>
                <Card className='stat-card'><CardContent className='stat-data'>
                    <AccountBoxIcon/>
                    <Typography>Average Sell:</Typography><Typography className={'the-stat'}>
                    {this.state.AverageSellPrice}</Typography>
                </CardContent></Card>
                <Card className='stat-card'><CardContent className='stat-data'>
                    <BusinessIcon/>
                    <Typography>Market VWAP:</Typography><Typography className={'the-stat'}>
                    {this.state.MarketVWAP}</Typography>
                </CardContent></Card>
                <Card className='stat-card'><CardContent className='stat-data'>
                    <BusinessIcon/>
                    <Typography>Last Price:</Typography><Typography className={'the-stat'}>
                    {this.state.LastPrice}</Typography>
                </CardContent></Card>
                <Card className='stat-card'><CardContent className='stat-data'>
                    <BusinessIcon/>
                    <Typography>Market Vol.:</Typography><Typography className={'the-stat'}>
                    {this.state.TotalVol}</Typography>
                </CardContent></Card>
              </div>
        );
    }
}

TotalStats.propTypes = {
    sessionid: PropTypes.string,
    uid: PropTypes.string
};

export default TotalStats;



// WEBPACK FOOTER //
// ./src/components/Orderbook/TotalStats.js